import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  isModal?: boolean;
}

const MENUITEMS: Menu[] = [
  {
    state: 'invoices',
    name: 'Invoices',
    type: 'link',
    icon: 'basic-todolist-pen'
  },
  {
    state: 'assignlob',
    name: 'Assign LOB',
    type: 'link',
    icon: 'rupee-sign',
    isModal: true
  },
  {
    state: 'creditnotes',
    name: 'Credit Notes',
    type: 'link',
    icon: 'ecommerce-creditcard'
  },
  {
    state: 'payadvance',
    name: 'Pay Advance',
    type: 'link',
    icon: 'ecommerce-rupee'
  },
  {
    state: 'statements',
    name: 'Download Statement',
    type: 'link',
    icon: 'basic-sheet-txt',
    isModal: true
  },
  {
    state: 'changepin',
    name: 'Change Pin',
    type: 'link',
    icon: 'basic-lock',
    isModal: true
  },
  {
    state: 'registeribp',
    name: 'Register for IBP',
    type: 'link',
    icon: 'basic-lock',
    isModal: true
  },
  {
    state: 'enach',
    name: 'e-ACH Mandate',
    type: 'link',
    icon: 'rupee-sign',
    isModal: true
  },
  {
    state: 'helpandsupport',
    name: 'V-Guard Help and Support',
    type: 'link',
    icon: 'basic-smartphone',
    isModal: true
  },
  {
    state: 'assigncnsd',
    name: 'Assign CN to Security Deposit',
    type: 'link',
    icon: 'basic-smartphone',
    isModal: true
  },
  {
    state: 'rtrLink',
    name: 'Request To Reconcile',
    type: 'link',
    icon: 'basic-smartphone',
    isModal: true
  },
  {
    state: 'contact',
    name: 'Contact Us',
    type: 'link',
    icon: 'basic-smartphone',
    isModal: true
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  add(menu: Menu) {
    MENUITEMS.push(menu);
  }

}
